import { observable } from 'mobx';
import * as Constants from '../Constants';

export class PartnersStore {

    @observable items = [];
    @observable isLoading = true;

    constructor() {
       this.load();
    }

    async load() {
        this.isLoading = true;
        fetch(Constants.TOBOGAURL + '/nadace/partners')
            .then(response => response.json())
            .then(data => {
                data.forEach(item => this.items.push(item));
                this.isLoading = false;
            });
    }
}